import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

interface PageHeaderInfo {
  title: string;
  breadcrumb: string;
  /** Omit for a page's own title line: no back button, larger title. */
  onBack?: () => void;
}

interface PageHeaderContextType {
  headerInfo: PageHeaderInfo | null;
  setHeaderInfo: (info: PageHeaderInfo | null) => void;
}

const PageHeaderContext = createContext<PageHeaderContextType>({
  headerInfo: null,
  setHeaderInfo: () => {},
});

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [headerInfo, setHeaderInfo] = useState<PageHeaderInfo | null>(null);
  const value = useMemo(
    () => ({ headerInfo, setHeaderInfo }),
    [headerInfo],
  );
  return (
    <PageHeaderContext.Provider value={value}>
      {children}
    </PageHeaderContext.Provider>
  );
}

export function usePageHeader() {
  return useContext(PageHeaderContext);
}
